import { render } from "./edit-store.vue?vue&type=template&id=0932247c&scoped=true"
import script from "./edit-store.vue?vue&type=script&lang=js"
export * from "./edit-store.vue?vue&type=script&lang=js"

import "./edit-store.vue?vue&type=style&index=0&id=0932247c&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0932247c"]])

export default __exports__